import React from "react";
const RewriteHelloWorldPage = () => (
  <div>
    <h1>Hello World</h1>
  </div>
);

export default RewriteHelloWorldPage;
